'use strict';
import SearchPageContentComponent from './search-page.component';

const searchPageComponentName = 'mxSearchPageContent';

const searchPageStateName = 'searchPage';

export default angular
	.module('mx.sb.SearchPage', [])
	.run([
		'mx.shell.RoutingService',
		function (routingService) {
			const searchPageRoute = routingService.createRoutingItem(getSearchRouteParams(searchPageStateName, '/search-page/:navigationId/:filterType/:filterId?'));
			const modernLookSearchPageRedirectRoute = routingService.createRoutingItem(getModernLookSearchPageRouteRedirect());
			routingService.searchPageRoute = searchPageRoute;

			routingService.addItems([
				routingService.createRoutingItem(getSearchRouteParams('createObjectExternally', '/:navigationId/create-object/:entityType')),
				routingService.createRoutingItem(getSearchRouteParams('editObjectExternally', '/:navigationId/edit-object/:entityType/:objectId')),
				routingService.createRoutingItem(
					getSearchRouteParams('previewObjectExternally', '/:navigationId/preview-object/:entityType/:objectId/:_archived/:previewWidgetId?')
				),
				searchPageRoute,
				modernLookSearchPageRedirectRoute,
				routingService.createRoutingItem(getCustomDataSetRouteOptions()),
			]);
		},
	])
	.component(searchPageComponentName, SearchPageContentComponent).name;

function getModernLookSearchPageRouteRedirect() {
	return {
		name: 'modernLookSearchPageRedirect',
		path: '/search-page/:navigationId?:structures:filters',
		title: 'Search Page',
		params: {
			navigationId: 'notset',
			structures: '',
			filters: '',
			viewType: null,
		},
		redirectTo: async ($transition$) => {
			const navigationService = $transition$.injector().get('mx.shell.NavigationService');

			const params = $transition$.params();
			let navigationId = params.navigationId.toLowerCase();
			const structures = params.structures.toLowerCase();
			const filters = params.filters.toLowerCase();
			let filterType;
			let filterId = '';

			if (structures.length) {
				filterType = 'structure';
				const firstStructure = structures.split(',')[0];
				filterId = firstStructure.split('_').at(0);
				navigationId = `${firstStructure}_${navigationId}`;
			} else if (filters.length) {
				const filterIDs = filters.split(',');

				const filterItems = (await Promise.all(filterIDs.map((id) => navigationService.getNavigationItem(id)))).filter((item) => item);
				filterItems.sort((item1, item2) => item2.level - item1.level);
				const filterItem = filterItems[0] || (await navigationService.getNavigationItem(navigationId));
				filterId = filterItem?.parameters?.filterId || '';
				filterType = filterItem?.parameters?.filterType || 'nofilter';
			} else {
				const navigationItem = await navigationService.getNavigationItem(navigationId);
				filterType = navigationItem?.parameters?.filterType || 'nofilter';
				filterId = navigationItem?.parameters?.filterId || '';
			}

			return $transition$.router.stateService.target(searchPageStateName, {
				viewType: params.viewType,
				navigationId,
				filterType,
				filterId,
			});
		},
	};
}

function getSearchRouteParams(name, urlTemplate) {
	return {
		name: name,
		path: urlTemplate,
		title: 'Search Page',
		component: searchPageComponentName,
		params: {
			navigationId: 'notset',
			filterType: 'nofilter',
			filterId: '',
			viewType: null,
			extraFilter: '',
		},
		redirectTo: async ($transition$) => {
			const navigationService = $transition$.injector().get('mx.shell.NavigationService');
			const deepLinkingService = $transition$.injector().get('mx.SolutionBuilderAgent.DeepLinkingService');
			const navigationId = $transition$.params().navigationId.toLowerCase();
			const navigationItem = await navigationService.getNavigationItem(navigationId);
			const state = $transition$.to();
			deepLinkingService.tryOpenDialog(state.name, $transition$.params(), navigationItem);

			if (navigationId !== 'notset' && navigationItem === null && !deepLinkingService.parseViewOptionsFromUrl()) {
				console.error('Search page navigation is not found!');
				return '404';
			}
		},
		resolve: {
			contentWidgetId: [
				'$transition$',
				'mx.shell.NavigationService',
				async ($transition$, navigationService) => {
					const navigationId = $transition$.params().navigationId.toLowerCase();
					if (navigationId === 'notset') {
						return;
					}
					return ((await navigationService.getNavigationItem(navigationId)) || {}).contentWidgetId;
				},
			],
			filterType: ['$transition$', ($transition$) => $transition$.params().filterType],
			filterId: ['$transition$', ($transition$) => $transition$.params().filterId],
			navigationId: ['$transition$', ($transition$) => $transition$.params().navigationId],
			viewType: [
				'$transition$',
				($transition$) => {
					const viewType = $transition$.params().viewType;
					return viewType !== null ? Number(viewType) : viewType;
				},
			],
			extraFilter: ['$transition$', ($transition$) => $transition$.params().extraFilter],
		},
	};
}

function getCustomDataSetRouteOptions() {
	const customDataSetRouteOptions = getSearchRouteParams('customDataSet', '/dataSet/:contentWidgetId/:filterType/:filterId?/:viewType?');
	delete customDataSetRouteOptions.redirectTo;
	Object.assign(customDataSetRouteOptions.resolve, {
		searchContext: searchContextResolver,
		contentWidgetId: ['$transition$', ($transition$) => $transition$.params().contentWidgetId],
	});
	return customDataSetRouteOptions;
}

searchContextResolver.$inject = ['$transition$', 'mx.SolutionBuilderAgent.ContentWidgetService', 'mx.shell.SearchProviderService'];
function searchContextResolver($transition$, contentWidgetService, searchService) {
	const contentWidgetId = $transition$.params().contentWidgetId;
	return contentWidgetService.getHtml(contentWidgetId).then(function (widget) {
		if (!widget) {
			return;
		}
		const context = new mx.SolutionBuilderAgent.SearchContext({
			name: 'custom_' + contentWidgetId,
			title: widget.Name,
			parameters: {
				appString: $transition$.params().appString,
				contentWidgetId: contentWidgetId,
				filterId: $transition$.params().filterId,
				filterType: $transition$.params().filterType,
				viewType: $transition$.params().viewType,
			},
			dataQuery: widget.DataQueryId,
			widgetId: contentWidgetId,
		});
		//TODO: refactor work of search-service with contexts
		searchService.setCustomDataSetContext(context);
		return context;
	});
}
